import {
  showFilterOverlay as showFilterOverlayAction,
  hideFilterOverlay,
  showSortOverlay as showSortOverlayAction,
  hideSortOverlay,
  toggleSecondaryList,
  updateViewportCategory as updateViewportCategoryAction,
  updateClientWidth,
  showSuccessMessage,
  hideSuccessMessage,
  setDetectedFloor,
} from ".";
import { analyticsOpenFilterSmall } from "../analytics/actions";
import { setViewportCategoryCookie } from "./columnCount";

export { toggleSecondaryList, hideFilterOverlay, hideSortOverlay };
export { updateClientWidth, showSuccessMessage, hideSuccessMessage };
export { setDetectedFloor };
export function showFilterOverlay() {
  return (dispatch) => {
    dispatch(showFilterOverlayAction());
    dispatch(analyticsOpenFilterSmall());
  };
}

export function showSortOverlay() {
  return (dispatch) => {
    dispatch(showSortOverlayAction());
  };
}

export const updateViewportCategory = (viewportCategory) => {
  setViewportCategoryCookie(viewportCategory);

  return updateViewportCategoryAction(viewportCategory);
};
